import React from 'react';
import { t } from '../../helpers/translate.js';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggleForm = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  render() {
    const { isOpen } = this.state;

    return (
      <div className={`contact-form-container ${isOpen ? 'open' : ''}`}>
        <button 
          type="button" 
          className="contact-toggle" 
          onClick={this.toggleForm}
        >
          <span className="toggle-text">{t('Partner Support')}</span>
        </button>
        <div className="contact-form-body">
          <h4 className="contact-title">
            {t('Contact Us if you require Assistance')}
          </h4>
          <p className="contact-subtitle">
            {t('Please contact us for assistance or submit a request and a representative will get back to you.')}
          </p>
          <div className="contact-details">
            <p><strong>{t('Email')}:</strong> Agent@americas.msh-intl.com</p>
            <p><strong>{t('Fax')}:</strong> 416-730-1878 ({t('or toll-free at')} 1-800-292-9460)</p>
            <p><strong>{t('By mail')}:</strong> {t('150 King St West, Suite 602, P.O. Box 75, Toronto, ON, M5H 1J9, Canada')}</p>
            <p>
              <strong>{t('Hours of operation')}:</strong><br />
              {t('Monday to Friday – 9 AM to 5 PM EST')}<br />
              ({t('We are open most holidays, 9 AM to 5 PM')})
            </p>
            <p className="contact-note">
              <strong>{t('Note')}:</strong> {t('Quebec applicants will be contacted by a representative before further steps.')}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

ContactForm.displayName = 'ContactForm';
export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/common/ContactUsBanner.js